type ClassNames<ComponentName extends string, Slot extends string> = {
  root: ComponentName
} & {
  [K in Slot]: `${ComponentName}__${K}`
}

export default function generateClassNames<
  ComponentName extends string,
  Slot extends string,
>(
  componentName: ComponentName,
  slots: Slot[]
): ClassNames<ComponentName, Slot> {
  const classes: any = {
    root: componentName,
  }

  slots.forEach((slot) => {
    classes[slot] = `${componentName}__${slot}`
  })

  return classes
}
